import styled from 'styled-components';

import {
    BoxscoreInfoContainer
} from './boxscoreTeam/BoxscoreInfo.style';

export const BoxscoreTeamWrapper = styled.div.attrs({
    'data-mlb-test': 'gamedayBoxscoreTeam'
})`
    width: 100%;
    max-width: 100%;
    ${BoxscoreInfoContainer} {
        margin-top: 18px;
        margin-bottom: 18px;
    }
`;

export const BoxscoreTeamNoteWrapper = styled.div.attrs({
    'data-mlb-test': 'gamedayBoxscoreTeamNote'
})`
`;

export const BoxscoreTeamNotesWrapper = styled.div.attrs({
    'data-mlb-test': 'gamedayBoxscoreTeamNotes'
})`
    width: 100%;
    max-width: 100%;
    margin-top: 9px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.54;
    color: var(--gameday-secondary-font-color);
    font-family: var(--gameday-primary-font);
`;
